<template>
  <div class="box">
    <a-row :gutter="24">
      <a-col :md="24">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item key="enterpriseDict">企业字典</a-menu-item>
          <a-menu-item key="standardDict">标准字典</a-menu-item>
        </a-menu>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典名称">
                    <a-input placeholder="请输入字典名称" v-model="queryParam.dictName"/>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典编码">
                    <a-input placeholder="请输入字典编码" v-model="queryParam.dictCode"/>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                    <a-select  v-model="queryParam.status">
                      <a-select-option value="0">正常</a-select-option>
                      <a-select-option value="1">停用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :md="24">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="6" :sm="24">
                      <a-button type="primary" @click="searchQuery">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    </a-col>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator"  style="margin-top: 5px">
            <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
            <!-- <a-button @click="batchDel" icon="delete">删除</a-button> -->
          </div>

          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="uuid"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="handleDictContent(record)">字典配置</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.uuid)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="customRenderFlag" slot-scope="enabled">
                <a-tag v-if="enabled==1" color="green">启用</a-tag>
                <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
              </template>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!-- 表单区域 -->
    <codeDict-modal ref="modalForm" @ok="modalFormOk" :current="current"></codeDict-modal>

    <!-- 字典配置 -->
    <codeDict-modal2 ref="modalForm2" @ok="modalFormOk"></codeDict-modal2>

    <!-- 规则节点区域 -->
    <a-drawer title="字典列表" placement="right" :visible="visibleDictContent" :after-visible-change="afterVisibleChange"
              @close="onClose" :maskClosable="false" :mask="false" width="87vw">
      <CodeDictDrawer :uuid="uuid"></CodeDictDrawer>
    </a-drawer>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CodeDictModal from './modules/codeDictModal.vue'
  import CodeDictModal2 from './modules/codeDictDrawer.vue';
  export default {
    name: "list",
    mixins:[JeecgListMixin],
    components: {
      CodeDictModal,
      CodeDictModal2
    },
    data() {
      return {
        current: ['enterpriseDict'], // 顶部导航栏

        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },
        
        // 查询条件
        queryParam: {
          isStandard: '1'
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:40,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 150,
            align:"center",
            scopedSlots: { customRender: 'action' },
          },
          {title: '字典名称 ', dataIndex: 'dictName', width: 80, align:"center"},
          {title: '字典编码 ', dataIndex: 'dictCode', width: 80, align:"center"},
          {title: '更新时间 ', dataIndex: 'updateTime', width: 80, align:"center"},
          {title: '状态', dataIndex: 'status', width: 80, align:"center",
            customRender: (qve) => {
              if (qve === '0') {
                return '正常';
              } else if (qve === '1') {
                return '停用';
              }
              return '未知状态';
            }
          },
        ],
        url: {
          list: "/codeRules/fzNodeDictionary/page",
          delete: "/codeRules/fzNodeDictionary/delete",
          deleteBatch: "/codeRules/fzNodeDictionary/deleteBatch"
        },
        visibleDictContent: false, // 规则节点抽屉开关
        uuid: '' // 每一项的uuid
      }
    },
    methods: {
      // 规则节点抽屉关闭 - 点击事件
      onClose() {
        this.visibleDictContent = false
      }
    },
    watch: {
      current() {
        this.queryParam.isStandard = this.current[0] === 'enterpriseDict' ? '1' : '0' // 规则查询参数
        this.searchReset() // 调用 - 重置
      }
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>